export const GET_ALL_CARTRULE_MENU_REQUESTED = 'GET_ALL_CARTRULE_MENU_REQUESTED';
export const GET_ALL_CARTRULE_MENU_SUCCEEDED = 'GET_ALL_CARTRULE_MENU_SUCCEEDED';

export const GET_CARTRULE_TEMPLATE_REQUESTED = 'GET_CARTRULE_TEMPLATE_REQUESTED';
export const GET_CARTRULE_TEMPLATE_SUCCEEDED = 'GET_CARTRULE_TEMPLATE_SUCCEEDED';

export const CARTRULE_COMP = 'CARTRULE_COMP';
